import { Box, Flex, Heading, Icon, Image, Link } from "@chakra-ui/react";
import { FaDiscord, FaLink } from "react-icons/fa";
import { IMAGE_PREFIX } from "~/core/constants";
import { ProjectDocument } from "~/core/types";
import StorageImage from "../StorageImage";

export default function HeadingSection({
  project,
}: {
  project: ProjectDocument;
}) {
  return (
    <>
      <Box position="relative" height={{ base: 150, lg: 200 }} zIndex={-1}>
        {project.createdForAppId ? null : (
          <>
            <Image
              src={
                project.hasMobileBanner
                  ? `${IMAGE_PREFIX}project/${project?.id}/banner_mobile.jpg?v=${project.version}`
                  : `${IMAGE_PREFIX}project/${project?.id}/banner.jpg?v=${project.version}`
              }
              display={{
                base: "initial",
                lg: "none",
              }}
              alt={`${project?.name} banner`}
              objectFit="cover"
              width={"100%"}
              height={"100%"}
              objectPosition={"center"}
            />

            <Image
              src={
                project.hasTabletBanner
                  ? `${IMAGE_PREFIX}project/${project?.id}/banner_tablet.jpg?v=${project.version}`
                  : `${IMAGE_PREFIX}project/${project?.id}/banner.jpg?v=${project.version}`
              }
              display={{
                base: "none",
                lg: "initial",
                xl: "none",
              }}
              alt={`${project?.name} banner`}
              objectFit="cover"
              width={"100%"}
              height={"100%"}
              objectPosition={"center"}
            />

            <Image
              src={`${IMAGE_PREFIX}project/${project?.id}/banner.jpg?v=${project.version}`}
              display={{
                base: "none",
                xl: "initial",
              }}
              alt={`${project?.name} banner`}
              objectFit="cover"
              width={"100%"}
              height={"100%"}
              objectPosition={"center"}
            />
          </>
        )}
      </Box>

      <Box p={6} mt={"-3.5rem"}>
        <Flex marginX="auto" maxW={{ base: "100vw", xl: 1200 }}>
          {project.createdForAppId ? null : (
            <Box
              width={{ base: 120, lg: 160 }}
              height={{ base: 120, lg: 160 }}
              border="solid 4px white"
              borderRadius={"50%"}
              boxShadow="0 0 2px black"
              overflow={"hidden"}
            >
              <StorageImage
                path={`project/${project?.id}/image.jpg?v=${project.version}`}
                alt={`${project?.name} image`}
                width={152}
                height={152}
                objectPosition="center"
                objectFit="cover"
              />
            </Box>
          )}

          <Flex
            ml="auto"
            mt="3rem"
            mr={{ xl: "33rem", base: 0 }}
            direction="column"
          >
            {project?.officialLink && (
              <Link
                target={"_blank"}
                href={project.officialLink}
                display="flex"
                alignItems="center"
                fontSize="sm"
                ml="auto"
              >
                <Icon mr={2} as={FaLink}></Icon>{" "}
                {project.officialLink.replace("https://", "")}
              </Link>
            )}
            {project?.discord?.serverLink && (
              <Link
                target={"_blank"}
                href={project.discord.serverLink}
                display="flex"
                alignItems="center"
                fontSize="sm"
                ml="auto"
              >
                <Icon mr={2} as={FaDiscord}></Icon>{" "}
                {project.discord.serverLink?.replace("https://", "")}
              </Link>
            )}
          </Flex>
        </Flex>

        <Box marginX="auto" maxW={{ base: "100vw", xl: 1200 }}>
          <Heading fontSize="24px" fontWeight="700" mt={4}>
            {project?.name}
          </Heading>
        </Box>
      </Box>
    </>
  );
}
